import * as React from "react";
import { Context, useContext } from "react";
import { isNil } from "ramda";

import { useAffinityFormReturn } from "affinityForm";
import { ExecuteButton } from "affinityForm/components/executeButton";
import { ButtonVariants, NavigateButton } from "affinityUI/elements/button";
import { Card } from "affinityUI/elements/card";
import { ButtonGroup } from "affinityUI/form/components";

import { PatientFormData, UpdatePatientFormData } from "../types";

import PatientSummary from "./patientSummary";

export const PatientConfirmation: React.FC<{
  context:
    | Context<Maybe<useAffinityFormReturn<UpdatePatientFormData>>>
    | Context<Maybe<useAffinityFormReturn<PatientFormData>>>;
}> = ({ context }) => {
  const formContext = useContext(context as Context<Maybe<useAffinityFormReturn<PatientFormData>>>);
  const patient = formContext?.formData;

  if (!isNil(patient)) {
    return (
      <Card>
        <PatientSummary formLink=".." patient={patient} />
        <ButtonGroup>
          <NavigateButton variant={ButtonVariants.SECONDARY} to="../..">
            Cancel
          </NavigateButton>
          <ExecuteButton>Confirm and save patient info</ExecuteButton>
        </ButtonGroup>
      </Card>
    );
  } else {
    return <>Error...</>;
  }
};
